import React from 'react';
import PropTypes from 'prop-types';
import withActiveUsersData from 'containers/withActiveUsersData';
import withBangingAnimator from 'containers/withBangingAnimator';
import A11yFontIcon from 'components/A11yFontIcon';
import ProfileIcon from 'components/ProfileIcon';
import TextButton from 'components/TextButton';
import { displayUserShape } from 'utils/shapes';
import './ActiveUsersDisplay.css';

const PER_PAGE_COUNT = 5;

function GuestsOnline({ value }) {
  return (
    <div className="player-count">
      <div className="player-count-value notranslate">{value}</div>
      <div className="player-count-label translate">Online</div>
    </div>
  );
}

const AnimatedGuestsOnline = withBangingAnimator()(GuestsOnline);

function ActiveUsersDisplay({ activeUsers, onPrevButton, onNextButton }) {
  const { totalUsers, users, offset } = activeUsers;

  if (!users || totalUsers === undefined) {
    return <div className="active-users-display" />;
  }

  const result = [];
  onPrevButton && addPage(result, 'prev', users, offset, -PER_PAGE_COUNT);
  addPage(result, 'curr', users, offset, 0);
  onNextButton && addPage(result, 'next', users, offset, +PER_PAGE_COUNT);

  return (
    <div className="active-users-display notranslate">
      <AnimatedGuestsOnline value={totalUsers} delay={0} snapDown={false} />
      <div className="player-list" aria-hidden="true">
        <TextButton
          onClick={onPrevButton}
          disabled={!onPrevButton}
          className="scroll-button"
          aria-hidden="true"
          tabIndex="-1"
        >
          <A11yFontIcon
            icon="chevron-left"
            alt="Previous"
            className={!onPrevButton ? 'fa-disabled' : ''}
          />
        </TextButton>

        <div className="pages">{result}</div>

        <TextButton
          onClick={onNextButton}
          disabled={!onNextButton}
          className="scroll-button"
          aria-hidden="true"
          tabIndex="-1"
        >
          <A11yFontIcon
            icon="chevron-right"
            alt="Next"
            className={!onNextButton ? 'fa-disabled' : ''}
          />
        </TextButton>
      </div>
    </div>
  );
}

function addPage(result, pageClass, users, offset, dir) {
  let start = offset + dir;
  let end = Math.min(start + PER_PAGE_COUNT, users.length);
  start = Math.max(start, 0);
  const align = dir < 0 ? PER_PAGE_COUNT - (end - start) : 0;

  for (let index = start; index < end; ++index) {
    const user = users[index];
    const posClass = 'player ' + pageClass + (index - start + align);
    result.push(
      <div key={user.userId} className={posClass} title={user.displayName}>
        <ProfileIcon
          withBorder
          avatarData={user && user.avatarData}
          size={30}
        />
        <div className="user-display-name">{user.displayName}</div>
      </div>
    );
  }
}

ActiveUsersDisplay.propTypes = {
  activeUsers: PropTypes.shape({
    totalUsers: PropTypes.number,
    users: PropTypes.arrayOf(displayUserShape),
    offset: PropTypes.number
  }),
  onPrevButton: PropTypes.func,
  onNextButton: PropTypes.func
};

export default withActiveUsersData({ usersPerPage: PER_PAGE_COUNT })(
  ActiveUsersDisplay
);
